/**
 * Client-safe PostHog config. Only exposes vars that are valid in the browser
 * bundle (`NEXT_PUBLIC_*`). Server-only vars (POSTHOG_API_KEY, personal API
 * key, project id) live in `./config.server` so this file can be imported
 * from any client component without t3-oss throwing.
 *
 * All env access goes through `@plura/shared/utils` (t3-oss/env-core) — the
 * `runtimeEnv` mapping there is what makes `NEXT_PUBLIC_*` vars available in
 * the browser bundle. Never read `process.env` directly here.
 */
import { env } from '@plura/shared/utils';

export const POSTHOG_HOST =
  env.NEXT_PUBLIC_POSTHOG_HOST ?? 'https://us.i.posthog.com';

export const POSTHOG_BROWSER_KEY = env.NEXT_PUBLIC_POSTHOG_KEY;

/**
 * Browser-only enabled check. The server has its own check in `config.server`
 * that includes the server key fallback.
 */
export function isPostHogEnabled(): boolean {
  return Boolean(POSTHOG_BROWSER_KEY);
}
